module.exports = __webpack_public_path__ + "img/app-user-monochrome.10d2046e.svg";